















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import BaseComponent from '@/core/base.component';
import { CodeManagementDto } from '@/services/init/dto';
import {
  GENDER,
  CONST_GENDER,
  APPROVAL_STATUS,
  B2B_FOUNDER_CONSULT,
} from '@/services/shared';
import CodeManagementService from '@/services/code-management.service';
import FounderConsultService from '@/services/founder-consult.service';
import DeliveryFounderConsultService from '@/services/delivery-founder-consult.service';
import AdminService from '@/services/admin.service';
import FoodCategoryService from '@/services/food-category.service';
import FounderConsultManagementService from '@/services/founder-consult-management.service';
import {
  AdminDto,
  AdminListDto,
  DeliveryFounderConsultDto,
  DeliveryFounderConsultUpdateDto,
  FounderConsultManagementDto,
  AdminSendMessageDto,
  CompanyDistrictDto,
  CompanyDto,
  DeliverySpaceDto,
  FoodCategoryDto,
  FoodCategoryListDto,
  DeliveryFounderConsultRecordDto,
  EditedMessageDto,
  DeliveryFounderConsultReplyDto,
  DeliveryFounderConsultReplyListDto,
  DeliverySpaceCreateDto,
} from '@/dto';
import { Pagination, YN, CONST_YN } from '@/common';
import { BaseUser } from '@/services/shared/auth';
import AnalysisSummary from '../../../modules/analysis/components/AnalysisSummary.vue';
import AnalysisSales from '../../../modules/analysis/components/AnalysisSales.vue';
import AnalysisCategory from '../../../modules/analysis/components/AnalysisCategory.vue';
import AnalysisPopulation from '../../../modules/analysis/components/AnalysisPopulation.vue';
import BaseCard from '../../_components/BaseCard.vue';
import FounderConsultManagementHistory from './FounderConsultManagementHistory.vue';
import toast from '../../../../resources/assets/js/services/toast.js';
import { FOUNDER_CONSULT, CONST_FOUNDER_CONSULT } from '@/services/shared';
import SmsService from '@/services/sms.service';
import { getStatusColor } from '@/core/utils/status-color.util';
import {
  ProductionEnvironment,
  DevelopmentEnvironment,
  EnvironmentType,
  Environment,
} from '../../../../environments';
import CompanyService from '@/services/company.service';
import CompanyDistrictService from '@/services/company-district.service';
import DeliverySpaceService from '@/services/delivery-space.service';
import DeliveryFounderConsultReplyService from '@/services/delivery-founder-consult-reply.service';

// environment variables
let env = new Environment();
if (process.env.NODE_ENV === EnvironmentType.development) {
  env = DevelopmentEnvironment;
}
if (process.env.NODE_ENV === EnvironmentType.production) {
  env = ProductionEnvironment;
}

@Component({
  name: 'DeliveryFounderConsultDetail',
  components: {
    AnalysisSummary,
    AnalysisSales,
    AnalysisCategory,
    AnalysisPopulation,
    BaseCard,
    FounderConsultManagementHistory,
  },
})
export default class FounderConsultDetail extends BaseComponent {
  /* global kakao */

  private editedMessageDto = new EditedMessageDto();
  private adminList: AdminDto[] = [];
  private adminListDto = new AdminListDto();
  private adminListCount = 0;
  private availableTimesSelect: CodeManagementDto[] = [];
  private delYn: YN[] = [...CONST_YN];
  private deliveryFounderConsultDto = new DeliveryFounderConsultDto();
  private deliveryFounderConsultMap = new DeliveryFounderConsultDto();
  private deliveryFounderConsultUpdateDto = new DeliveryFounderConsultUpdateDto();
  private deliveryFounderConsultStatusSelect: CodeManagementDto[] = [];
  private genderSelect: CodeManagementDto[] = [];
  private foodCategorySelect: FoodCategoryDto[] = [];
  private pagination = new Pagination();
  private selectedAdmin: AdminDto = new AdminDto(BaseUser);
  private deliveryFounderConsultManagements: FounderConsultManagementDto[] = [];
  private elapsedTime = null;
  private deliveredTime = new Date();
  private createdTime = new Date();
  private statusDistComplete = false;
  private adminSendMessageDto = new AdminSendMessageDto();
  private homepageSiteUrl = env.homepageSiteUrl;
  private dataLoading = false;
  private isSeoul = false;
  private availableCompanies: CompanyDto[] = [];
  private availableDistricts: CompanyDistrictDto[] = [];
  private availableSpaces: DeliverySpaceDto[] = [];
  private deliveryFounderConsultRecordList: DeliveryFounderConsultRecordDto[] = [];
  private companySelect = '';
  private districtSelect = '';
  private paginationReply = new Pagination();
  private deliveryFounderConsultReplyTotalCount = null;
  private deliveryFounderConsultReplyDto: DeliveryFounderConsultReplyDto = new DeliveryFounderConsultReplyDto();
  private deliveryFounderConsultReplyList: DeliveryFounderConsultReplyDto[] = [];
  private deliveryFounderconsultReplyListDto = new DeliveryFounderConsultReplyListDto();
  private deliveryFounderConsultReplyCreateDto = new DeliveryFounderConsultReplyDto();

  private map;
  private bdongCode = null;
  private revenueClicked = false;
  private categoryClicked = false;
  private populationClicked = false;

  // get status color
  getStatusColor(
    status: APPROVAL_STATUS | B2B_FOUNDER_CONSULT | FOUNDER_CONSULT,
  ) {
    return getStatusColor(status);
  }

  // 사용자 정보 수정
  // updateNanudaUser() {
  //   if (this.deliveryFounderConsultDto.nanudaUser.gender) {
  //     this.deliveryFounderConsultUpdateDto.gender = this.deliveryFounderConsultDto.nanudaUser.gender;
  //   }
  //   this.getGender();
  // }

  // 상담 내용 수정
  // updateConsultInfo() {
  //   this.deliveryFounderConsultUpdateDto = this.deliveryFounderConsult;
  //   this.getFounderConsultCodes();
  //   this.getAvailableTimes();
  //   this.getFoodCategories();
  //   this.getGender();
  // }

  reverseReadStatus() {
    DeliveryFounderConsultService.reverseReadStatus(
      this.$route.params.id,
    ).subscribe(res => {
      this.findOne(this.$route.params.id);
    });
  }

  // send message to user
  sendMessage() {
    this.adminSendMessageDto.phone = this.deliveryFounderConsultDto.nanudaUser.phone;
    SmsService.sendMessage(this.adminSendMessageDto).subscribe(res => {
      if (res) {
        this.adminSendMessageDto = new AdminSendMessageDto();
        toast.success('문자가 발송 되었습니다.');
      } else {
        return;
      }
    });
  }

  showVicinityInfoModal() {
    this.dataLoading = true;
    DeliveryFounderConsultService.sendMessageAndPlaceInIndex(
      this.$route.params.id,
    ).subscribe(res => {
      this.dataLoading = false;
      if (res) {
        this.editedMessageDto.message = res.data;
      }
    });
  }

  sendVicinityInfo() {
    DeliveryFounderConsultService.sendVicinityMessage(
      this.deliveryFounderConsultDto.nanudaUser.no,
      this.editedMessageDto,
    ).subscribe(res => {
      if (res) {
        this.$bvModal.hide('send_analysis');
        toast.success('문자가 발송 되었습니다.');
        this.findOne(this.deliveryFounderConsultDto.no);
      }
    });
  }

  // 담당자 본인으로 정하기
  assignYourselfAdmin() {
    DeliveryFounderConsultService.assignAdmin(
      this.deliveryFounderConsultDto.no,
    ).subscribe(res => {
      this.findOne(this.deliveryFounderConsultDto.no);
    });
  }

  // 성별
  getGender() {
    CodeManagementService.findGender().subscribe(res => {
      this.genderSelect = res.data;
    });
  }

  // 희망 상담 시간
  getAvailableTimes() {
    CodeManagementService.findAvailableTimes().subscribe(res => {
      this.availableTimesSelect = res.data;
    });
  }

  changeCompany(event) {
    const companyNo = event.target.value;
    this.getAvailableDistricts(companyNo);
  }

  changeDistricts(event) {
    const companyDistrictNo = event.target.value;
    this.getAvailableSpaces(companyDistrictNo);
  }

  // 신청 상태 코드
  getFounderConsultCodes() {
    CodeManagementService.findCodesFounderConsult().subscribe(res => {
      this.deliveryFounderConsultStatusSelect = res.data;
    });
  }

  getAvailableCompanies() {
    CompanyService.findForSelect().subscribe(res => {
      this.availableCompanies = res.data;
    });
  }

  getAvailableDistricts(companyNo) {
    const districtDto = new CompanyDistrictDto();
    districtDto.companyNo = companyNo;
    CompanyDistrictService.findForSelectOption(districtDto).subscribe(res => {
      this.availableDistricts = res.data;
    });
  }

  getAvailableSpaces(companyDistrictNo) {
    const deliverySpaceDto = new DeliverySpaceDto();
    deliverySpaceDto.companyDistrictNo = companyDistrictNo;
    DeliverySpaceService.findForSelect(deliverySpaceDto).subscribe(res => {
      this.availableSpaces = res.data;
    });
  }

  findOne(id) {
    // find founder consult detail
    DeliveryFounderConsultService.findOne(id).subscribe(res => {
      if (res) {
        this.deliveryFounderConsultDto = res.data;
        this.deliveredTime = res.data.deliveredAt;

        if (this.deliveredTime) {
          this.createdTime = new Date(res.data.createdAt);
          this.deliveredTime = new Date(res.data.deliveredAt);
          this.getElapsedTime(this.createdTime, this.deliveredTime);
        }
        if (this.deliveryFounderConsultDto.status === 'F_DIST_COMPLETE') {
          this.statusDistComplete = true;
        }

        if (
          this.deliveryFounderConsultDto.deliverySpace &&
          this.deliveryFounderConsultDto.deliverySpace.companyDistrict
        ) {
          const withInSeoul = this.deliveryFounderConsultDto.deliverySpace
            .companyDistrict.region1DepthName;
          if (withInSeoul === '서울') {
            this.isSeoul = true;
          }
        }

        this.findConsultReply();
      }
    });
  }

  changeDeliverySpace() {
    DeliveryFounderConsultService.changeDeliverySpace(
      this.deliveryFounderConsultDto.no,
      this.deliveryFounderConsultUpdateDto.newDeliverySpaceNo,
    ).subscribe(res => {
      if (res) {
        toast.success('주방 변경 완료');
        this.companySelect = null;
        this.districtSelect = null;
        this.deliveryFounderConsultUpdateDto.newDeliverySpaceNo = null;
        this.findOne(this.deliveryFounderConsultDto.no);
      } else {
        this.companySelect = null;
        this.districtSelect = null;
        this.deliveryFounderConsultUpdateDto.newDeliverySpaceNo = null;
      }
    });
  }

  // 경과 시간
  getElapsedTime(startTime, endTime) {
    const timeDiff = Math.abs(
      (this.deliveredTime as any) - (this.createdTime as any),
    );
    const inMinutes = 60 * 1000;
    const inHours = 36e5;

    if (timeDiff > inHours) {
      this.elapsedTime = Math.ceil(timeDiff / inHours) + '시간';
    } else {
      this.elapsedTime = Math.ceil((timeDiff % inHours) / inMinutes) + '분';
    }
  }

  /**
   * find space change records
   */
  findSpaceChangeRecord() {
    DeliveryFounderConsultService.findSpaceChangeRecords(
      this.deliveryFounderConsultDto.no,
    ).subscribe(res => {
      this.deliveryFounderConsultRecordList = res.data;
    });
  }

  /**
   * find delivery founder consult reply
   */

  findConsultReply(isPagination?: boolean) {
    this.paginationReply.limit = 5;
    if (!isPagination) {
      this.paginationReply.page = 1;
    }

    DeliveryFounderConsultReplyService.findAll(
      this.deliveryFounderConsultDto.no,
      this.deliveryFounderconsultReplyListDto,
      this.paginationReply,
    ).subscribe(res => {
      if (res) {
        this.deliveryFounderConsultReplyList = res.data.items;
        this.deliveryFounderConsultReplyTotalCount = res.data.totalCount;
      }
    });
  }

  createConsultReply() {
    DeliveryFounderConsultReplyService.create(
      this.deliveryFounderConsultDto.no,
      this.deliveryFounderConsultReplyCreateDto,
    ).subscribe(res => {
      if (res) {
        toast.success('작성완료');
        this.deliveryFounderConsultReplyCreateDto = new DeliveryFounderConsultReplyDto();
        this.findOne(this.$route.params.id);
      }
    });
  }

  paginateReply() {
    this.findConsultReply(true);
  }

  /**
   * find admin
   */
  selectAdmin(admin: AdminDto) {
    this.selectedAdmin = admin;
  }

  cancelSelection() {
    this.selectedAdmin = new AdminDto(BaseUser);
  }

  findAdmin(isPagination: boolean) {
    if (!isPagination) {
      this.pagination.page = 1;
    }
    this.pagination.limit = 5;
    AdminService.findAll(this.adminListDto, this.pagination).subscribe(res => {
      this.adminList = res.data.items;
      this.adminListCount = res.data.totalCount;
    });
  }

  paginateSearch() {
    this.findAdmin(true);
  }

  // 음식 업종
  getFoodCategories() {
    FoodCategoryService.findForSelect().subscribe(res => {
      this.foodCategorySelect = res.data;
    });
  }

  // update for delivery founder consulut
  updateFounderConsult() {
    if (this.selectedAdmin) {
      this.deliveryFounderConsultDto.spaceConsultManager = this.selectedAdmin.no;
    }

    if (this.deliveryFounderConsultDto.nanudaUser.gender) {
      this.deliveryFounderConsultDto.gender = this.deliveryFounderConsultDto.nanudaUser.gender;
    }

    DeliveryFounderConsultService.update(
      this.deliveryFounderConsultDto.no,
      this.deliveryFounderConsultDto,
    ).subscribe(res => {
      this.cancelSelection();
      // this.deliveryFounderConsultDto = new DeliveryFounderConsultUpdateDto();
      this.findOne(this.$route.params.id);
      toast.success('수정완료');
    });
  }

  // 지도 가져오기
  setMap(id) {
    DeliveryFounderConsultService.findOne(id).subscribe(res => {
      if (res) {
        this.deliveryFounderConsultMap = res.data;

        if (
          this.deliveryFounderConsultMap.deliverySpace &&
          this.deliveryFounderConsultMap.deliverySpace.companyDistrict
        ) {
          const mapContainer = document.getElementById('map'),
            mapOption = {
              center: new window.kakao.maps.LatLng(
                this.deliveryFounderConsultMap.deliverySpace.companyDistrict.lat,
                this.deliveryFounderConsultMap.deliverySpace.companyDistrict.lon,
              ),
              level: 5,
              maxLevel: 6,
              minLevel: 3,
              mapTypeId: window.kakao.maps.MapTypeId.ROADMAP,
            };

          const map = new window.kakao.maps.Map(mapContainer, mapOption);
          const content = `<span class="badge badge-primary" style="font-size:21px;border-radius: 100px;opacity: 82%">Here</span>`;
          const markerPosition = new window.kakao.maps.LatLng(
            this.deliveryFounderConsultMap.deliverySpace.companyDistrict.lat,
            this.deliveryFounderConsultMap.deliverySpace.companyDistrict.lon,
          );

          const customOverlay = new window.kakao.maps.CustomOverlay({
            position: markerPosition,
            content: content,
            // image: markerImage,
          });

          const circle = new window.kakao.maps.Circle({
            map: map,
            center: new window.kakao.maps.LatLng(
              this.deliveryFounderConsultMap.deliverySpace.companyDistrict.lat,
              this.deliveryFounderConsultMap.deliverySpace.companyDistrict.lon,
            ),
            strokeWeight: 2,
            strokeColor: '#FF00FF',
            strokeOpacity: 0.8,
            strokeStyle: 'dashed',
            fillColor: '#00EEEE',
            fillOpacity: 0.5,
          });
          circle.setRadius(1000);
          circle.setMap(map);
          customOverlay.setMap(map);
          this.map = map;
        }
      }
    });
  }

  created() {
    this.getAvailableCompanies();
    this.getGender();
    this.getFoodCategories();
    this.getFounderConsultCodes();
    this.findOne(this.$route.params.id);
    this.setMap(this.$route.params.id);
    // this.getFounderConsultManagements(founderConsultId);
  }
}
